<template>
  <div class="customer-points">
    <div v-if="isLoading" class="text-center p-5">
      <b-spinner variant="primary" label="Đang tải..."></b-spinner>
      <p class="mt-2">Đang tải thông tin điểm thưởng...</p>
    </div>

    <div v-else-if="pointInfo">
      <!-- Point Summary Card -->
      <b-card class="border mb-4">
        <b-row>
          <b-col md="4" class="border-right">
            <div class="text-center">
              <h6 class="text-muted mb-2">Điểm hiện tại</h6>
              <h3 class="font-weight-bold text-primary">
                {{ pointInfo.data.currentPoints }}
              </h3>
            </div>
          </b-col>

          <b-col md="4" class="border-right">
            <div class="text-center">
              <h6 class="text-muted mb-2">Tổng điểm tích lũy</h6>
              <h3 class="font-weight-bold">
                {{ pointInfo.data.lifetimePoints }}
              </h3>
            </div>
          </b-col>

          <!-- <b-col md="4">
            <div class="text-center">
              <h6 class="text-muted mb-2">Hạng thành viên</h6>
              <h3
                class="font-weight-bold"
                :style="{ color: pointInfo.data.rank?.colorHex || '#000' }"
              >
                {{ pointInfo.data.rank?.name || 'Chưa có hạng' }}
              </h3>
            </div>
          </b-col> -->
        </b-row>
      </b-card>

      <!-- Member Rank Card -->
      <b-card v-if="pointInfo.rank" class="border mb-4">
        <b-card-title>Thông tin hạng thành viên</b-card-title>

        <b-row>
          <b-col md="6">
            <b-list-group flush>
              <b-list-group-item
                class="d-flex justify-content-between align-items-center"
              >
                <span>Hạng thành viên:</span>
                <span
                  class="font-weight-bold"
                  :style="{ color: pointInfo.data.rank.colorHex }"
                >
                  {{ pointInfo.data.rank.name }}
                </span>
              </b-list-group-item>

              <b-list-group-item
                class="d-flex justify-content-between align-items-center"
              >
                <span>Mã hạng:</span>
                <span>{{ pointInfo.data.rank.code }}</span>
              </b-list-group-item>

              <b-list-group-item
                class="d-flex justify-content-between align-items-center"
              >
                <span>Tỷ lệ tích điểm:</span>
                <span>x{{ pointInfo.data.rank.pointMultiplier }}</span>
              </b-list-group-item>
            </b-list-group>
          </b-col>

          <b-col md="6">
            <div class="progress-points">
              <h6>Tiến trình lên hạng:</h6>
              <b-progress
                :value="pointInfo.data.currentPoints"
                :max="nextRankPoints || 1000"
                height="25px"
                show-progress
                class="mb-2"
              ></b-progress>
              <div class="d-flex justify-content-between">
                <small>{{ pointInfo.data.currentPoints }} điểm</small>
                <small v-if="nextRankPoints"
                  >Còn {{ nextRankPoints - pointInfo.data.currentPoints }} điểm
                  để lên hạng kế tiếp</small
                >
              </div>
            </div>
          </b-col>
        </b-row>
      </b-card>

      <!-- Quick Actions Card -->
      <b-card class="border mb-4">
        <b-card-title>Thao tác nhanh</b-card-title>

        <b-row>
          <b-col>
            <b-button
              variant="success"
              size="sm"
              class="mr-2"
              @click="showAddPointsModal = true"
            >
              <i class="fa fa-plus-circle mr-1"></i>
              Thêm điểm
            </b-button>
            <!-- 
            <b-button
              variant="primary"
              size="sm"
              class="mr-2"
              @click="showRedeemPointsModal = true"
              :disabled="!pointInfo.currentPoints"
            >
              <i class="fa fa-exchange-alt mr-1"></i>
              Đổi điểm
            </b-button> -->

            <b-button
              variant="info"
              size="sm"
              @click="showAdjustPointsModal = true"
            >
              <i class="fa fa-edit mr-1"></i>
              Điều chỉnh điểm
            </b-button>
          </b-col>
        </b-row>
      </b-card>
    </div>

    <div v-else class="text-center p-5">
      <p class="text-muted">Không có thông tin điểm thưởng</p>
    </div>

    <!-- Add Points Modal -->
    <b-modal
      v-model="showAddPointsModal"
      title="Thêm điểm"
      header-bg-variant="light"
      @ok.prevent="submitAddPoints"
      @hidden="resetPointsForm"
    >
      <b-form @submit.prevent="submitAddPoints">
        <b-form-group label="Số điểm:">
          <b-form-input
            v-model="pointsForm.points"
            type="number"
            min="0"
            :max="
              pointsForm.adjustmentType === 'subtract'
                ? pointInfo?.data.currentPoints || 0
                : null
            "
            required
            placeholder="Nhập số điểm"
          ></b-form-input>
          <small
            v-if="pointsForm.adjustmentType === 'subtract'"
            class="text-muted"
          >
            Điểm hiện có: {{ pointInfo?.data.currentPoints || 0 }}
          </small>
        </b-form-group>

        <b-form-group label="Lý do:">
          <b-form-input
            v-model="pointsForm.reason"
            placeholder="Nhập lý do điều chỉnh"
            required
          ></b-form-input>
        </b-form-group>

        <b-form-group label="Mô tả chi tiết:">
          <b-form-textarea
            v-model="pointsForm.description"
            rows="3"
            placeholder="Nhập mô tả chi tiết"
          ></b-form-textarea>
        </b-form-group>

        <b-form-group label="Yêu cầu phê duyệt:">
          <b-form-checkbox v-model="pointsForm.requiresApproval">
            Yêu cầu phê duyệt trước khi thực hiện
          </b-form-checkbox>
        </b-form-group>
      </b-form>

      <template #modal-footer="{ cancel }">
        <b-button variant="secondary" @click="cancel()">
          Hủy
        </b-button>
        <b-button
          variant="info"
          @click="submitAdjustPoints"
          :disabled="
            !isPointsFormValid ||
              isSubmitting ||
              (pointsForm.adjustmentType === 'subtract' &&
                pointsForm.points > (pointInfo?.data.currentPoints || 0))
          "
        >
          <b-spinner small v-if="isSubmitting"></b-spinner>
          Điều chỉnh
        </b-button>
      </template>
    </b-modal>

    <point-adjustment-modal
      :show="showAdjustPointsModal"
      @update:show="showAdjustPointsModal = $event"
      :customer-id="customerId"
      :current-points="pointInfo?.data.currentPoints || 0"
      @adjustment-success="fetchPointInfo"
    />
  </div>
</template>

<script>
import {
  defineComponent,
  ref,
  computed,
  reactive,
  watch,
  onMounted,
} from 'vue';
import datePicker from 'vue-bootstrap-datetimepicker';
import ApiService from '@/core/services/api.service';
import moment from 'moment';
import { makeToastSuccess, makeToastFaile } from '@/utils/common';
import PointAdjustmentModal from './PointAdjustmentModal.vue';
import emitter from '@/core/services/emitter';

export default defineComponent({
  name: 'CustomerPointsTab',

  components: {
    datePicker,
    PointAdjustmentModal,
  },

  props: {
    customerId: {
      type: [String, Number],
      required: true,
    },
  },

  setup(props) {
    const pointInfo = ref(null);
    const isLoading = ref(false);
    const isSubmitting = ref(false);
    const nextRankPoints = ref(null);

    // Modals
    const showAddPointsModal = ref(false);
    const showRedeemPointsModal = ref(false);
    const showAdjustPointsModal = ref(false);

    // Form data
    const pointsForm = reactive({
      points: 0,
      source: '',
      sourceId: '',
      description: '',
      expiryDate: '',
      reason: '',
      adjustmentType: 'add',
      requiresApproval: false,
    });

    const dateConfig = {
      format: 'DD/MM/YYYY',
      useCurrent: false,
      showClear: true,
      showClose: true,
      locale: 'vi',
      sideBySide: true,
    };

    const sourceOptions = [
      { value: 'MANUAL', text: 'Thủ công' },
      { value: 'PROMOTION', text: 'Khuyến mãi' },
      { value: 'EVENT', text: 'Sự kiện' },
      { value: 'REFERRAL', text: 'Giới thiệu' },
    ];

    const redeemOptions = [
      { value: 'REWARD', text: 'Phần thưởng/Voucher' },
      { value: 'PRODUCT', text: 'Sản phẩm' },
      { value: 'SERVICE', text: 'Dịch vụ' },
      { value: 'GIFT', text: 'Quà tặng' },
    ];

    const isPointsFormValid = computed(() => {
      return pointsForm.points > 0;
    });

    const fetchPointInfo = async () => {
      if (!props.customerId) return;

      isLoading.value = true;
      try {
        const response = await ApiService.get(
          `/v1/customer-points/${props.customerId}`,
        );

        if (response.data && response.data.value) {
          pointInfo.value = response.data.value;
        } else {
          pointInfo.value = response.data;
        }

        if (pointInfo.value && pointInfo.value.rank) {
          try {
            const ranksResponse = await ApiService.get(`/v1/customer-ranks`);
            const ranks = ranksResponse.data.data || [];
            const currentRankIndex = ranks.findIndex(
              (r) => r.id === pointInfo.value.rank.id,
            );

            if (
              currentRankIndex !== -1 &&
              currentRankIndex < ranks.length - 1
            ) {
              nextRankPoints.value = ranks[currentRankIndex + 1].minPoints;
            } else {
              nextRankPoints.value = null;
            }
          } catch (error) {
            console.error('Error fetching ranks:', error);
          }
        }
      } catch (error) {
        console.error('Error fetching point info:', error);
      } finally {
        isLoading.value = false;
      }
    };

    const resetPointsForm = () => {
      pointsForm.points = 0;
      pointsForm.source = '';
      pointsForm.sourceId = '';
      pointsForm.description = '';
      pointsForm.expiryDate = '';
      pointsForm.reason = '';
      pointsForm.adjustmentType = 'add';
      pointsForm.requiresApproval = false;
      isSubmitting.value = false;
    };

    const submitAddPoints = async () => {
      if (!isPointsFormValid.value) return;

      isSubmitting.value = true;
      try {
        const payload = {
          customerId: +props.customerId,
          points: parseInt(pointsForm.points),
          source: pointsForm.source,
          sourceId: pointsForm.sourceId || undefined,
          description: pointsForm.description,
        };

        if (pointsForm.expiryDate) {
          payload.expiryDate = moment(
            pointsForm.expiryDate,
            'DD/MM/YYYY',
          ).format('YYYY-MM-DDT00:00:00Z');
        }

        await ApiService.post('/v1/customer-points/earn', payload);
        makeToastSuccess('Thêm điểm thành công');
        showAddPointsModal.value = false;
        fetchPointInfo();
        // Emit event to notify transaction tab
        emitter.emit('points-updated');
      } catch (error) {
        console.error('Error adding points:', error);
        makeToastFaile('Không thể thêm điểm');
      } finally {
        isSubmitting.value = false;
      }
    };

    const submitRedeemPoints = async () => {
      if (!isPointsFormValid.value) return;
      if (pointsForm.points > (pointInfo.value?.currentPoints || 0)) return;

      isSubmitting.value = true;
      try {
        const payload = {
          customerId: +props.customerId,
          points: parseInt(pointsForm.points),
          source: pointsForm.source,
          sourceId: pointsForm.sourceId || undefined,
          description: pointsForm.description,
        };

        await ApiService.post('/customer-points/redeem', payload);
        makeToastSuccess('Đổi điểm thành công');
        showRedeemPointsModal.value = false;
        fetchPointInfo();
      } catch (error) {
        console.error('Error redeeming points:', error);
        makeToastFaile('Không thể đổi điểm');
      } finally {
        isSubmitting.value = false;
      }
    };

    const submitAdjustPoints = async () => {
      if (!isPointsFormValid.value) return;
      if (
        pointsForm.adjustmentType === 'subtract' &&
        pointsForm.points > (pointInfo.value?.currentPoints || 0)
      )
        return;

      isSubmitting.value = true;
      try {
        const payload = {
          customerId: +props.customerId,
          points:
            pointsForm.adjustmentType === 'subtract'
              ? -parseInt(pointsForm.points)
              : parseInt(pointsForm.points),
          reason: pointsForm.reason,
          description: pointsForm.description,
          requiresApproval: pointsForm.requiresApproval,
        };

        await ApiService.post('/v1/customer-points/adjust', payload);
        makeToastSuccess('Điều chỉnh điểm thành công');
        showAddPointsModal.value = false;
        resetPointsForm();
        fetchPointInfo();
        // Emit event to notify transaction tab
        emitter.emit('points-updated');
      } catch (error) {
        console.error('Error adjusting points:', error);
        makeToastFaile('Không thể điều chỉnh điểm');
      } finally {
        isSubmitting.value = false;
      }
    };

    const openAdjustModal = () => {
      showAdjustPointsModal.value = true;
    };

    watch(
      () => props.customerId,
      (newId) => {
        if (newId) {
          fetchPointInfo();
        }
      },
      { immediate: true },
    );

    onMounted(() => {
      if (props.customerId) {
        fetchPointInfo();
      }
    });

    return {
      pointInfo,
      isLoading,
      isSubmitting,
      nextRankPoints,
      showAddPointsModal,
      showRedeemPointsModal,
      showAdjustPointsModal,
      pointsForm,
      dateConfig,
      sourceOptions,
      redeemOptions,
      isPointsFormValid,
      fetchPointInfo,
      resetPointsForm,
      submitAddPoints,
      submitRedeemPoints,
      submitAdjustPoints,
      openAdjustModal,
    };
  },
});
</script>

<style scoped>
.progress-points {
  padding: 1rem;
}
</style>
